import { IBulkParcelUploadImportValidationConstraint } from "../bulk-parcel-upload-import-validator";
import { BulkParcelUploadDataReader } from "../bulk-parcel-upload-data-reader";
import { t } from "i18next";
import { context } from "../../../../../../context/context";
import { Permission } from "../../../../../../context/permission";

export class BulkParcelUploadParcelStockoutConstraint implements IBulkParcelUploadImportValidationConstraint {
    public validateHeader(headerColumns: string[]) {
        if (headerColumns.filter(c => c === BulkParcelUploadDataReader.columnNameQuantityStockout).length !== 1) {
            throw new Error(t("bulkParcelUpload.error.headerQuantityStockoutMissing"));
        }

        return true;
    }

    public validateLine(lineNumber: number, content: Map<string, string>) {
        return context.hasPermission(Permission.FeatureParcelStockouts) ?
            this.validateForParcelStockoutEnabled(lineNumber, content) :
            this.validateForParcelStockoutDisabled(lineNumber, content);
    }

    public validateForParcelStockoutEnabled(lineNumber: number, content: Map<string, string>) {
        const quantityStockout = Number(content.get(BulkParcelUploadDataReader.columnNameQuantityStockout));
        const quantityAssigned = Number(content.get(BulkParcelUploadDataReader.columnNameQuantityAssigned));
        const parcelId = content.get(BulkParcelUploadDataReader.columnParcelId);

        if ((parcelId ?? "") !== "" && quantityStockout > quantityAssigned) {
            throw new Error(t("bulkParcelUpload.error.unableToStockoutMoreThanInParcel", { lineNumber }));
        }

        return true;
    }

    public validateForParcelStockoutDisabled(lineNumber: number, content: Map<string, string>) {
        const quantityStockout = Number(content.get(BulkParcelUploadDataReader.columnNameQuantityStockout));
        const parcelId = content.get(BulkParcelUploadDataReader.columnParcelId);

        if (quantityStockout > 0 && parcelId !== "") {
            throw new Error(t("bulkParcelUpload.error.unableToParcelStockout", { lineNumber, parcelId }));
        }

        return true;
    }
}
